import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environment/environment';

@Injectable({
  providedIn: 'root',
})
export class PermissionsService {
  constructor(private http: HttpClient) {}

  getPermissions(): Observable<any> {
    return this.http.get(`${environment.authUrl}/modules`);
  }

  getPermissionsById(id: any): Observable<any> {
    return this.http.get(`${environment.authUrl}/role-permissions/role/${id}`);
  }

  updatePermission(roleId: any, data: any): Observable<any> {
    return this.http.put(`${environment.authUrl}/role-permissions/role/${roleId}`, data);
  }
}
